export default ".outer-container {\n  min-width: 300px;\n}";